import axios, { AxiosError } from 'axios';

export interface HealthResponse {
    Name: string;
    Healthy: boolean;
    ElapsedMs: number;
    RegionName: string;
    InstanceId: string;
    Version: string;
    BuildId: string;
    CommitHash: string;
    BuildDateTime: string;
    Components: HealthComponent[];
}

export interface HealthComponent {
    Name: string;
    Healthy: boolean;
    ElapsedMs: number;
    Details: string;
}

export default async function getApimDependencyHealth(
    path: string,
    getToken: () => Promise<string>
): Promise<HealthResponse> {
    return await axios
        .get<HealthResponse>(`${process.env.AUCTIONS_GATEWAY_BASEURL}${path}`, {
            headers: {
                Authorization: `Bearer ${await getToken()}`,
            },
        })
        .then(response => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            console.error(err);
            return { Name: path, Healthy: false, Components: [] } as HealthResponse;
        });
}

export async function getSimpleDependencyHealth(
    path: string,
    getToken: () => Promise<string>
): Promise<string> {
    return await axios
        .get<string>(`${process.env.AUCTIONS_GATEWAY_BASEURL}${path}`, {
            headers: {
                Authorization: `Bearer ${await getToken()}`,
            },
        })
        .then(response => {
            return response.status === 200 ? 'Healthy' : 'Unhealthy';
        })
        .catch((err: AxiosError) => {
            console.error(err);
            return 'Unhealthy';
        });
}

export interface RemoteResponse {
    Name: string;
    Url: string;
    Status: number;
    Size: string;
    ElapsedMs: number;
}

export async function getRemoteHealth(name: string, path: string): Promise<RemoteResponse> {
    const startMs = new Date().getTime();
    return await axios
        .get(path)
        .then(response => {
            const stopTime = new Date().getTime();
            return {
                Name: name,
                Url: path,
                Status: response.status,
                ElapsedMs: stopTime - startMs,
                Size: (response.data.length / 1024).toFixed(2),
            } as RemoteResponse;
        })
        .catch((err: AxiosError) => {
            console.error(err);
            return {
                Name: name,
                Url: path,
                Status: 500,
                Size: '0',
                ElapsedMs: 0,
            } as RemoteResponse;
        });
}
